<template>
	<v-container fluid :class="leaveId !== 0 ? 'pa-0':''">
		<div v-if="leaveId !== 0" class="top-line"></div>
		<v-alert type="error" v-if="error_msg.length !== 0">
			{{ error_msg	}}
		</v-alert>
		<v-alert type="warning" v-if="warning_msg.length !== 0">
			{{ warning_msg }}
		</v-alert>
		<div :class="[leaveId === 0 ? 'leave-content':'leave-content-desktop', from_other || leaveType !== null ? '':'pa-6']">
			<v-row class="ma-0" no-gutters>
				<v-row v-if="leave_id !== 0" :class="leaveId !== 0 ? 'ma-0 px-3 pt-4':''" no-gutters justify="space-between" :align="'center'">
					<div style="color:#C18014;font-weight: 500">Leave</div>
					<div class="task-title">
						<div v-if="current_leave && (current_leave.leave_paid || current_leave.is_used_on_payslip)" class="button paid-button text-capitalize" style="opacity: 0.5; width: 100px;">{{ leave_status }}</div>
						<div v-if="current_leave && !current_leave.leave_paid && !current_leave.is_used_on_payslip && !approvePrivilege" class="button paid-button text-capitalize" style="opacity: 0.5; width: 100px;">{{ leave_status }}</div>
						<v-select
							v-if="current_leave && !current_leave.leave_paid && !current_leave.is_used_on_payslip && approvePrivilege"
							style="width: 140px"
							class="selection my-2"
							v-model="approve_select"
							:items="approve_option"
							:item-color="'#C18014'"
							:color="'#FFFFFF'"
							:background-color="'#C18014'"
							:menu-props="{ bottom: true, offsetY: true}"
							append-icon="mdi-chevron-down"
							dense
							hide-details
							return-object
							solo
							@click.stop
							@change="onStatusChange($event)"
						>
							<template v-slot:selection="{ item }">
								<span>{{ item.text }}d</span>
							</template>
						</v-select>
						<v-icon class="ml-2"  @click.stop="onCancel()">mdi-close</v-icon>
					</div>
				</v-row>
				<span style="color:#C18014;font-weight: 500" v-else>Request Leave</span>
			</v-row>
			<ProgressGetDataLinear v-if="loading"/>
			<v-row v-if="!loading" no-gutters class="mt-4" :class="leaveId !== 0 ? 'mx-3':''">
				<v-col :cols="$vuetify.breakpoint.smAndDown? 12:9">
					<div class="task-title">
						<div class="leave-item-title">Leave type</div>
						<v-icon v-if="leave_id !== 0" small>mdi-lock-outline</v-icon>
					</div>
					<v-select
						v-model="leave_event_type"
						:color="color_local"
						:disabled="leave_id !== 0"
						:items="event_types"
						item-text="desc"
						item-value="id"
						:item-color="color_local"
						hide-details
						return-object
						outlined
						dense
						background-color="#FAFAFA"
						@change="onButtonActive()"
					/>
				</v-col>
			</v-row>
			<v-row v-if="!loading && (is_other_leave ? approvePrivilege : true)" no-gutters :class="leaveId !== 0 ? 'mx-3':''">
				<v-col class="mt-4" cols="12">
					<div class="task-title">
						<div class="leave-item-title">Leave Description</div>
						<v-icon v-if="!can_edit" small>mdi-lock-outline</v-icon>
					</div>
					<v-text-field
						v-model="description"
						:color="color_local"
						:disabled="!can_edit"
						outlined
						dense
						background-color="#FAFAFA"
						hide-details
						@change="onButtonActive()"
					/>
				</v-col>
			</v-row>
			<v-row v-if="!loading" no-gutters :class="leaveId !== 0 ? 'mx-3 mt-3':'mt-3'" justify="space-between" :align="`start`">
				<div style="width: 74%">
					<template v-if="isAllday">
						<div class="task-title">
							<div class="leave-item-title">Start date to End date</div>
							<v-icon v-if="!can_edit" small>mdi-lock-outline</v-icon>
						</div>
						<div v-if="current_leave && current_leave.is_used_on_payslip" class="task-title mb-3">
							<DatePicker
								class="mr-3"
								style="width:45%"
								:suggestionText="''"
								:persistentHint="false"
								:color="color_local"
								:isOutlined="true"
								:isIcon="true"
								:isClear="false"
								:dateInit="start_date_init"
								:disabled="true"
							/>
							<DatePicker
								style="width:50%"
								:suggestionText="''"
								:persistentHint="false"
								:color="color_local"
								:isOutlined="true"
								:isIcon="true"
								:dateInit="end_date_init"
								:disabled="!can_edit"
								:validRange="date_range"
								valid-range-text-color="rgba(0, 0, 0, 0.87)"
								@date="onEndDateChange($event)"
							/>
						</div>
						<DateMulti
							v-else
							:suggestionText="$vuetify.breakpoint.smAndDown ? `eg, 12/3/2022-13/3/2022`:`eg, 120322-130322 or 12/3/2022-13/3/2022`"
							:color="color_local"
							:background="`#FAFAFA`"
							:dateStartInit="start_date_init"
							:dateEndInit="end_date_init"
							:disabled="!can_edit"
							@dateRange="onDateRangeChange($event)"
						/>
					</template>
					<template v-if="!isAllday">
						<div class="task-title">
							<div class="leave-item-title">Date</div>
							<v-icon v-if="!can_edit" small>mdi-lock-outline</v-icon>
						</div>
						<DatePicker
							style="width:100%"
							:suggestionText="`eg, 120322 or 12/3/2022`"
							:color="color_local"
							:isOutlined="true"
							:isIcon="true"
							:dateInit="start_date_init"
							:disabled="!can_edit"
							@date="onDateChange($event)"
						/>
					</template>
				</div>
				<v-checkbox
					class="mt-4"
					v-model="isAllday"
					:color="'#00AAFD'"
					dense
					hide-details
					:disabled="!can_edit || (current_leave && current_leave.is_used_on_payslip)"
					@change="onButtonActive()"
				>
					<template v-slot:label>
						<div class="leave-item-title">All day</div>
					</template>
				</v-checkbox>
			</v-row> 
			<v-row v-if="!loading && !isAllday" :class="leaveId !== 0 ? 'mx-3 my-0':'ma-0'">
				<DateTime
					:color="color"
					:startTimeInit="time_start_init"
					:endTimeInit="time_end_init"
					:startError="start_time_error"
					:endError="end_time_error || time_required"
					:disabled="!can_edit"
					:styleLeft="`pt-0 pl-0`"
					:styleRight="`pt-0 pr-0`"
					:is_lock="!can_edit"
					@time_start="onTimeStartChange($event)"
					@time_end="onTimeEndChange($event)"
				/>
			</v-row>
			<v-row v-if="!loading && leave_id !== 0" no-gutters class="mt-0 mb-3" :class="leaveId !== 0 ? 'mx-3':''">
				<v-col cols="12">
					<div class="task-title">
						<div class="leave-item-title">Time zone</div>
						<v-icon v-if="!can_edit" small>mdi-lock-outline</v-icon>
					</div>
					<v-autocomplete
						v-model="timezone"
						:items="timezone_items"
						:color="color"
						:menu-props="{ bottom: true, offsetY: true}"
						:loading="timezone_loading"
						:disabled="!can_edit"
						background-color="#FAFAFA"
						item-text="name"
						item-value="key"
						item-color="success"
						outlined
						dense
						hide-details
						return-object
						clearable
						@change="onTimezoneChange()"
					>
						<template v-slot:item="{item, on}">
							<v-list-item style="min-height: 32px">
								<v-row v-if="item.children !== 0" class="mt-2 mb-0">
									<v-col cols="12" class="py-0">
										<div class="step-item-text" style="font-weight: 500; color: rgba(25, 42, 62, 0.5)">{{ item.name }}</div>
									</v-col>
									<v-col cols="12" class="pt-1 pb-0">
										<v-divider></v-divider>
									</v-col>
								</v-row>
								<div v-if="item.children === 0" class="step-item-text step-item-text-hover" style="color: rgba(25, 42, 62, 1)" v-on="on">{{ item.name }}</div> 
							</v-list-item>
						</template>
					</v-autocomplete>
				</v-col>
			</v-row>
			<v-row v-if="!loading" no-gutters class="mt-1" :class="leaveId !== 0 ? 'mx-3':''">
				<v-col cols="12">
					<div class="task-title">
						<div class="leave-item-title">Send approval request to</div>
					</div>
					<v-autocomplete
						v-model="leave_approval_by"
						:color="color_local"
						:disabled="!can_edit"
						:items="leave_approval_by_items"
						item-color="secondary"
						item-text="desc"
						item-value="id"
						background-color="#FAFAFA"
						return-object
						hide-details
						outlined
						dense
						@change="onButtonActive()"
					/>
				</v-col>
			</v-row>
			<v-row v-if="!loading" :class="leaveId !== 0 ? 'mx-3':''" no-gutters>
				<v-col v-if="can_edit" cols="12" class="pt-6">
					<v-btn 
						block
						class="white--text text-capitalize"
						color="#00AAFD" 
						@click="save_leave()"  
						:disabled="!isActive"
					>
						Submit
					</v-btn>
				</v-col>
				<v-col v-if="can_edit" :cols="can_delete ? 6:12">
					<div :class="can_delete ? 'float-right':''">
						<v-btn
							:block="!can_delete"
							text
							class="mt-1 text-capitalize"
							color="#757575" 
							@click="onCancel()"  
						>
							Cancel
						</v-btn>
					</div>
				</v-col>
				<v-col v-if="can_delete" :cols="can_delete && !can_edit ? 12:6">
					<div :class="can_delete && !can_edit ? '':'float-left'">
						<v-btn
							:block="can_delete && !can_edit"
							text
							class="mt-1 text-capitalize" 
							color="#E10050" 
							@click="confirm_visible = true" 
							:disabled="!can_delete"
						>
							Delete Request
						</v-btn>
					</div>
				</v-col>
			</v-row>
			<v-dialog v-model="confirm_visible" max-width="320" scrollable>
				<v-alert
					class="mb-0"
					border="top"
					colored-border
					color="error"
				>
					<div class="button">
						<v-icon class="mr-3" color="error">mdi-alert</v-icon>
						<div>Are you sure you want to delete this leave request?</div>
					</div>
					<div class="button mt-2">
						<v-btn 
							class="text-capitalize mr-2"
							color="rgba(25, 42, 62, 0.7)"
							outlined
							@click="confirm_visible = false" 
						>
							Cancel
						</v-btn>
						<v-btn 
							class="text-capitalize white--text"
							depressed
							color="error" 
							@click="delete_leave()"
						>
							Delete Request
						</v-btn>
					</div>
				</v-alert>
			</v-dialog>
			<DialogNotice
				v-if="visible_notice" 
				:visible="visible_notice" 
				:text="notice_text"
				:color="notice_color"
			/>
		</div>
	</v-container>
</template>

<script>
import DateMulti from "@/components/date/date_multi.vue";
import DatePicker from "@/components/date/date_picker.vue";
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import DateTime from "@/components/date/date_time.vue";

import config from "@/config.js";
import moment from 'moment-timezone';
import { metaMixin } from "@/mixins/events/metaMixin";
import { validTime } from "@/common/validTime.js";

const Approve_Option = [
	{
		text: 'Approve',
		value: 'approved',
	},
	{
		text: 'Unapprove',
		value: 'unapprove',
	}
];

/** If selected the user can manage and approve leave events */
const DAppLeave = 'DAppLeave';

/** If selected the user can delete approved leave events if not already in a payslip */
const DDelAppLeave = 'DDelAppLeave';

/** If selected the user can manage public holidays */
const DPubHol = 'DPubHol';

/** If selected the user is allowed to approve payslips */
const PRapp = 'PRapp';


export default {
	name: 'LeaveEdit',
	mixins: [ metaMixin ],
	props: {
		leaveId: {
			type: Number,
			default: 0,
		},
		leaveType: {
			type: Object,
			default: null,
		},
		startDate: {
			type: String,
			default: '',
		},
		endDate: {
			type: String,
			default: '',
		},
		partialLeave: {
			type: Boolean,
			default: false,
		},
		partDate: {
			type: String,
			default: '',
		},
		startTime: {
			type: String,
			default: '',
		},
		endTime: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: '',
		}
	},
	components: {
		DateMulti,
		DatePicker,
		ProgressGetDataLinear,
		DialogNotice,
		DateTime
	},
	data() {
		this.approve_option = Approve_Option;

		return {
			loading: true,
			timezone_loading: false,

			error_msg: '',
			warning_msg: '',
			privileges: [],

			approve_select: null,

			leave_id: -1,
			leave_event_type: null,
			description: '',
			isAllday: true,

			date_range: [],
			start_date_init: '',
			end_date_init: '',
			start_date: '',
			end_date: '',

			start_time: '',
			end_time: '',
			time_start_init: '',
			time_end_init: '',

			start_time_error: false,
			end_time_error: false,

			menu_start_time: false,
			menu_end_time: false,

			timezone_items: [],
			timezone: null,
			user_timezone: '',
			leave_approval_by: { id: 0, desc: 'Do not send' },
			leave_approval_by_items: [{ id: 0, desc: 'Do not send' }],

			current_leave: null,
			isActive: false,
			confirm_visible: false,

			visible_notice: false,
			notice_text: [],
			tid: null,
			notice_color: '#00AAFD',
		}
	},
	async created() {
		this.load_meta_data();
		//this.getEmployeesAndFreelancers();
		this.getApprovalBy();

		await this.getTimezone();
		await this.getUserTimezone();

		if (this.$store.state.privileges && this.$store.state.privileges.length === 0) {
			this.initPrivileges();
		} else {
			this.privileges = this.$store.state.privileges;
		}

		if (this.$route.params.id) {
			/* if refresh, the type of 'this.$route.params.id' is string */
			const id = typeof(this.$route.params.id) === 'string' ? Number(this.$route.params.id) : this.$route.params.id;

			this.leave_id = id;

			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: id === 0 ? "Request Leave": `Edit Leave ${id}`,
				to: this.$route.path
			});

			if (id !== 0) {
				this.load(id);
			}
		} else if (this.leaveId !== 0) {
			this.leave_id = this.leaveId;
			this.load(this.leaveId);
		} else {
			this.leave_id = 0;
			this.leave_event_type = this.leaveType;
			this.isAllday = !this.partialLeave;

			if (this.partialLeave) {
				this.start_date_init = this.partDate;
				this.start_date = this.partDate;

				this.end_date_init = this.partDate;
				this.end_date = this.partDate;

				this.start_time = moment(this.startTime, 'h:mm a').format('h:mm a');
				this.end_time = moment(this.endTime, 'h:mm a').format('h:mm a');

				this.time_start_init = this.start_time ? this.start_time : '';
				this.time_end_init = this.end_time ? this.end_time : '';
			} else {
				this.start_date_init = this.startDate;
				this.start_date = this.startDate;

				this.end_date_init = this.endDate;
				this.end_date = this.endDate;
			}

			this.loading = false;
		}
	},
	computed: {
		from_other() {
			let is_from_other =  false;

			if (this.$route.params.evid) {
				is_from_other = true;
			}

			return is_from_other;
		},
		can_delete() {
			let isDelete =  false;

			if (this.leave_id === 0 ) {
				isDelete = false;
			} else {
				if (this.leave_id !== 0 && this.privileges.length !== 0 && this.user_abid !== 0 && this.current_leave) {
					if (this.current_leave.leave_paid || this.current_leave.is_used_on_payslip) {
						isDelete = false;
					} else {
						if (this.current_leave.leave_type === config.public_holiday_type) {
							isDelete = this.privileges.includes(DPubHol) ? true : false;
						} else {
							if (this.current_leave.leave_approved) {
								isDelete = this.privileges.includes(DDelAppLeave);
							} else {
								if (this.current_leave.employee.id === this.user_abid) {
									isDelete = true;
								} else {
									isDelete = this.privileges.includes(DAppLeave) ? true: false;
								}
							}
						}
					}
				}
			}			

			return isDelete;
		},
		can_edit() {
			let is_edit = false;

			if (this.leave_id === 0 ) {
				is_edit = true;
			} else {
				if (this.leave_id !== 0 && this.privileges.length !== 0 && this.user_abid !== 0 && this.current_leave) {
					if (this.current_leave.leave_paid) {
						is_edit = false;
					} else if (this.current_leave.is_used_on_payslip) {
						is_edit = this.privileges.includes(PRapp) && this.privileges.includes(DAppLeave) ? true: false;	
					} else {
						if (this.current_leave.leave_type === config.public_holiday_type) {
							if (this.current_leave.leave_approved) {
								is_edit = this.privileges.includes(DPubHol) && this.privileges.includes(DAppLeave) ? true : false;
							} else {
								is_edit = this.privileges.includes(DPubHol) ? true : false;
							}
						} else {
							if (this.current_leave.leave_approved) {
								is_edit = this.privileges.includes(DAppLeave) ? true: false;	
							} else {
								if (this.current_leave.employee.id === this.user_abid) {
									is_edit = true;
								} else {
									is_edit = this.privileges.includes(DAppLeave) ? true: false;
								}
							}
						}
					}
				}
			}			

			return is_edit;
		},
		color_local() {
			return this.color.length === 0 ? this.$attrs.color : this.color;
		},
		time_able() {
			let able = false;

			if (this.start_date && this.start_date.length !== 0 && this.end_date && this.end_date.length !== 0 && this.start_date === this.end_date) {
				able = true;
			}

			return able;
		},
		time_required() {
			let is_required = false;

			if (this.start_date && this.start_date.length !== 0 && this.end_date && this.end_date.length !== 0 && this.start_date === this.end_date) {
				if (this.start_time && this.start_time.length !== 0 && !this.end_time) {
					is_required = true;
				}
			}
			return is_required;
		},
		user_abid() {
			let abid = 0;
			const user = this.$store.state.user;

			if (user && user.addressbook) {
				abid = user.addressbook.id;
			}		

			return abid;
		},
		leave_status() {
			let status = '';

			if (this.current_leave) {
				if (this.current_leave.leave_paid) {
					status = this.current_leave.status_desc;
				} else {
					if (this.current_leave.leave_approved) {
						status = this.current_leave.status_desc;
					} else {
						status = 'Unapproved';
					}
				}
			}

			return status;
		},
		is_other_leave() {
			let is_other_leave = false;

			if (this.current_leave && this.user_abid !== 0) {
				if (this.current_leave.employee.id !== this.user_abid) {
					is_other_leave = true;
				}
			}
			return is_other_leave;
		},
		approvePrivilege() {
			let isApprovePrivilegeTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(DAppLeave)) {
				isApprovePrivilegeTmp = true;
			}
			return isApprovePrivilegeTmp;
		},
	},
	methods:{
		getApprovalBy() {
			let url = '/api/tasks/list_assignees';

			const params = [];
			// 3 = "Employees", 12 = 'Freelancers', from 'api/addressbook/meta'
			params.push("abook_types=" + encodeURIComponent("3, 12"));
			params.push("has_privilege=" + DAppLeave);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const approval_by = data[0].employees;
						approval_by.forEach(a => { a['desc'] = this._formatName(a.display_name) });
						approval_by.unshift(this.leave_approval_by);

						this.leave_approval_by_items = approval_by;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		getEmployeesAndFreelancers() {
			let url = '/api/tasks/list_assignees';

			const params = [];
			// 3 = "Employees", 12 = 'Freelancers', from 'api/addressbook/meta'
			params.push("abook_types=" + encodeURIComponent("3, 12"));

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const approval_by = data[0].employees;
						approval_by.forEach(a => { a['desc'] = this._formatName(a.display_name) });
						approval_by.unshift(this.leave_approval_by);

						this.leave_approval_by_items = approval_by;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getUserTimezone() {
			const url = '/api/user/me/timezone';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_timezone = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getTimezone() {
			this.timezone_loading = true;

			const url = '/api/support/timezones';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const timezone_group = {};

						const data_filter = data.filter(d => {
							const time_zone_key = d.value.toUpperCase();
							return !time_zone_key.includes(config.time_zone_keys[0]) && !time_zone_key.includes(config.time_zone_keys[1]);
						});
						data_filter.forEach(timezone => {
							const group_key = (timezone.value.split('/'))[0];
							const group_key_arr = Object.keys(timezone_group);

							if (group_key_arr.includes(group_key)) {
								const arr = timezone_group[`${group_key}`];

								const child = {
									key: timezone.value,
									name: `${(timezone.description.split(' '))[0]} (GMT${(timezone.description.split(' '))[1]})`,
									is_default: timezone.is_default,
									children: 0
								}

								timezone_group[`${group_key}`] = [...arr, child];
							} else {
								const child = {
									key: timezone.value,
									name: `${(timezone.description.split(' '))[0]} (GMT${(timezone.description.split(' '))[1]})`,
									is_default: timezone.is_default,
									children: 0
								}
								timezone_group[`${group_key}`] = [child];
							}
						});

						let timezone_list = [];
						for (const [key, value] of Object.entries(timezone_group)) {
							const node = {
								key: `parent_${key}`,
								name: key,
								is_default: false,
								children: value.length
							}
							timezone_list= [...timezone_list, node, ...value];
						}
						this.timezone_items = timezone_list;

						if (!this.isEdit && !this.isDuplication) {
							const default_timezone_arr = timezone_list.filter(timezone => { return timezone.is_default === true});
							this.timezone = default_timezone_arr.length !== 0 ? default_timezone_arr[0] : null;
						}
					} else {
						this.error_msg = reason;
						this.timezone_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.timezone_loading = false;
				})
				.finally(() => {
					this.timezone_loading = false;
				});
		},
		async initPrivileges() {
			this.loading = true;
			const url = "/api/user/me/privileges";
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}					
				})
				.then(val => {
					const {status, data}  = val.data;

					if (status === "OK") {
						this.privileges = data;
					}
				})
				.catch((e) => {
					console.log(e.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		load(leave_id) {			
			if (leave_id === 0) return;
			
			this.loading = true;
			const url = `/api/leave/${leave_id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						this.description = data.description;
						this.leave_event_type = data.event_type;
						this.event_types.push(data.event_type);
						this.isAllday = data.all_day;
						this.approve_select = data.leave_approved ? Approve_Option[0] : Approve_Option[1];

						const timezone_key = data.timezone && data.timezone.length !== 0 ? data.timezone : this.user_timezone;
						this.timezone = (this.timezone_items.filter(timezone => { return timezone.key === timezone_key }))[0];

						this.start_date_init = moment(data.start_date).format("YYYY-MM-DD");
						this.end_date_init = moment(data.end_date).format("YYYY-MM-DD");

						this.start_date = moment(data.start_date).format("YYYY-MM-DD");
						this.end_date = moment(data.end_date).format("YYYY-MM-DD");

						if (data.is_used_on_payslip) {
							this.date_range = [data.enddate_on_pay];
						}

						if (data.all_day) {
							this.start_time = '';
							this.end_time = '';

							this.time_start_init = this.start_time;
							this.time_end_init = this.end_time;

						} else {
							this.start_time = moment(data.start_date).format("h:mm a");
							this.end_time = moment(data.end_date).format("h:mm a");

							this.time_start_init = this.start_time ? this.start_time : '';
							this.time_end_init = this.end_time ? this.end_time : '';
						}

						this.current_leave = data;
						this.loading = false;

					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onEditLeaveClose() {
			this.$emit('close');
		},
		onStatusChange(status) {
			const is_holiday = this.current_leave.leave_type === config.public_holiday_type ? true : false;

			if (status.value === 'approved') {
				this._approveLeave(this.current_leave.id, this.current_leave.description, is_holiday);
			}

			if (status.value === 'unapprove') {
				this._unapproveLeave(this.current_leave.id, this.current_leave.description, is_holiday);
			}
			
		},
		onButtonActive() {
			this.isActive = this._isActive();
		},
		onDateRangeChange(value) {
			this.error_msg = '';
			this.warning_msg = '';

			if (value.length === 0) {
				this.start_date_init = '';
				this.end_date_init = '';

				this.start_date = '';
				this.end_date = '';
			}

			if (value.length === 2) {
				this.start_date_init = value[0];
				this.end_date_init = value[1];

				this.start_date = value[0];
				this.end_date = value[1];
			}
			
			this.onButtonActive();
			if (this.isActive) {
				this.date_check();
			}
		},
		onEndDateChange(value) {
			this.warning_msg = '';
			this.end_date_init = value ? value : '';
			this.end_date = value ? value : '';
			
			if (this.end_date.length !== 0 && this.end_date < this.current_leave.enddate_on_pay) {
				const date = moment(this.current_leave.enddate_on_pay).format('DD MMM YYYY');
				this.warning_msg = `The end date can't exceed ${date} because it is paid up to that date.`;
			}

			this.onButtonActive();
			if (this.isActive) {
				this.date_check();
			}
		},
		onDateChange(value) {
			this.start_date_init = value ? value : '';
			this.end_date_init = value ? value : '';

			this.start_date = value ? value : '';
			this.end_date = value ? value : '';

			this.onButtonActive();
			if (this.isActive) {
				this.date_check();
			}
		},
		date_check() {
			this.error_msg = '';
			this.warning_msg = '';

			const start_date = moment(this.start_date).format('YYYYMMDD');
			const end_date = this.end_date ? moment(this.end_date).format('YYYYMMDD') : '';

			const params = [];

			if (this.current_leave && this.current_leave.employee.id !== 0) {
				params.push("employees=" + this.current_leave.employee.id);
			} else {
				const user = this.$store.state.user;
				params.push("employees=" + user.addressbook.id);
			}

			if (start_date.length !== 0) {
				params.push('start_date='+ start_date);
			}

			if (end_date.length !== 0) {
				params.push('end_date='+ end_date);
			}
			
			params.push("event_types=" + [2,3,4,5,6]);

			let url = "/api/leave";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						let exist_leaves = 0;
						if (this.leave_id !== 0) {
							const other_leaves = data.filter(d => { return d.id !== this.leave_id });
							exist_leaves = other_leaves.length;
						} else {
							exist_leaves = data.length;
						}

						if (exist_leaves > 0) {
							this.warning_msg = 'A leave request already exists for the selected date';
						}							
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onTimezoneChange() {
			this.isActive = this._isActive();
		},
		onTimeStartChange(time) {
			this.error_msg = '';
			this.warning_msg = '';
			this.start_time_error = false;
			this.end_time_error = false;

			this.start_time = time;

			this._timeCheck(true);
			this.onButtonActive();
		},
		onTimeEndChange(time) {
			this.error_msg = '';
			this.warning_msg = '';
			this.start_time_error = false;
			this.end_time_error = false;

			this.end_time = time;

			this._timeCheck(false);
			this.onButtonActive();
		},
		save_leave(){
			if (this.leave_id !== 0) {
				/** timezone conversion */
				const start_date_tmp = this.isAllday ?
					moment(`${this.start_date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
					: moment(`${this.start_date} ${this.start_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');

				const end_date_tmp = this.isAllday?
					moment(`${this.end_date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
					: moment(`${this.start_date} ${this.end_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');

				moment.tz.setDefault(this.timezone.key);
				const timezone_start_date = moment(start_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
				const timezone_end_date = moment(end_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
				moment.tz.setDefault(this.user_timezone);

				const start_date = moment(timezone_start_date).utc().format('YYYY-MM-DD HH:mm:ss Z');
				const end_date = moment(timezone_end_date).utc().format('YYYY-MM-DD HH:mm:ss Z');

				const params = {
					event_type_id: this.leave_event_type.id,
					description: this.description,
					all_day: this.isAllday,
					start_date: start_date,
					end_date: end_date,
					duration: 0,
					timezone: this.timezone.key,
					is_approved: false
				};

				if (this.leave_approval_by && this.leave_approval_by.id !== 0) {
					params['approval_by'] = this.leave_approval_by.id;
				}

				this._updateLeave(this.leave_id, params);
			}

			if (this.leave_id === 0) {
				/** timezone conversion */
				const start_date_tmp = this.isAllday?
					moment(`${this.start_date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
					: moment(`${this.start_date} ${this.start_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');

				const end_date_tmp = this.isAllday ?
					moment(`${this.end_date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
					: moment(`${this.start_date} ${this.end_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');

				moment.tz.setDefault(this.timezone.key);
				const timezone_start_date = moment(start_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
				const timezone_end_date = moment(end_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
				moment.tz.setDefault(this.user_timezone);

				const start_date = moment(timezone_start_date).utc().format('YYYY-MM-DD HH:mm:ss Z');
				const end_date = moment(timezone_end_date).utc().format('YYYY-MM-DD HH:mm:ss Z');
				
				const params = {
					event_type_id: this.leave_event_type.id,
					description: this.description,
					all_day: this.isAllday,
					start_date: start_date,
					end_date: end_date,
					duration: 0,
					timezone: this.user_timezone,
					is_approved: false,
				};

				if (this.leave_approval_by && this.leave_approval_by.id !== 0) {
					params['approval_by'] = this.leave_approval_by.id;
				}

				this._createLeave(params);
			}
		},
		delete_leave (){
			this.confirm_visible = false;

			const url = `/api/leave/${this.leave_id}`;

			axios
				.delete(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (this.leaveId === 0) {
							const path = this.$route.params.path;
							if (path) {
								this.$router.push(path)
							} else {
								this.$router.push({ name: "Leave"});
							}
						} else {
							this.$emit('close')
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onCancel(){
			if (this.leaveId === 0) {
				const path = this.$route.params.path;
				if (path) {
					this.$router.push(path)
				} else {
					this.$router.push({ name: "Leave"});
				}
			} else {
				this.$emit('close')
			}
		},
		_createLeave(params) {
			const url = "/api/leave";

			axios
				.post(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						if (this.leaveId === 0 && this.from_other) {
							this.$emit('close')
						} else {
							const path = this.$route.params.path;
							if (path) {
								this.$router.push(path)
							} else {
								this.$router.push({ name: "Leave"});
							}
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		_updateLeave(id, params) {
			const url = `/api/leave/${id}`;

			axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						if (this.leaveId === 0) {
							const path = this.$route.params.path;
							if (path) {
								this.$router.push(path)
							} else {
								this.$router.push({ name: "Leave"});
							}
						} else {
							this.$emit('close')
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});	
		},
		_approveLeave(id, name, is_public_holiday=false) {
			const url = `/api/leave/${id}/approve`;

			axios
				.get(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (this.leaveId === 0) {
							if (is_public_holiday) {
								this.notice_text.push(`Public Holiday ‘(${name})’ has been approved successfully.`);
							} else {
								this.notice_text.push(`Leave ‘(${name})’ has been approved successfully.`);
							}
							this.visible_notice = true;
							this.tid = setTimeout(this._close, 2000);
						} else {
							this.$emit('close')
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_unapproveLeave(id, name, is_public_holiday=false) {
			const url = `/api/leave/${id}/unapprove`;

			axios
				.get(url, {}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (this.leaveId === 0) {
							if (is_public_holiday) {
								this.notice_text.push(`Public Holiday ‘(${name})’ has been unapproved successfully.`);

							} else {
								this.notice_text.push(`Leave ‘(${name})’ has been unapproved successfully.`);
							}
							this.visible_notice = true;
							this.tid = setTimeout(this._close, 2000);
						} else {
							this.$emit('close')
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_isActive() {
			let isActive = false;
			if (this.leave_id === 0) {
				if (this.leave_event_type && this.description.length !== 0 && this.start_date && this.start_date.length !== 0 && this.end_date && this.end_date.length !== 0) {
					if (!this.isAllday) {
						const start_24_hour = this.start_time ? moment(this.start_time, 'h:mm a').format('HH:mm') : '';
						const end_24_hour = this.end_time ? moment(this.end_time, 'h:mm a').format('HH:mm') : '';

						if (start_24_hour.length !== 0 && end_24_hour.length !== 0 && start_24_hour < end_24_hour) {
							isActive = true;
						}
					}

					if (this.isAllday && this.start_date <= this.end_date) {
						isActive = true;
					}
				}
			}

			if (this.leave_id !== 0) {
				let valid = false;

				if (this.current_leave.is_used_on_payslip) {
					valid = this.start_date !== null && this.start_date.length !== 0 && this.end_date !== null && this.end_date.length !== 0 && this.start_date <= this.end_date && this.end_date >= this.current_leave.enddate_on_pay;
				} else {
					if (this.isAllday) {
						valid = this.start_date !== null && this.start_date.length !== 0 && this.end_date !== null && this.end_date.length !== 0 && this.start_date <= this.end_date;
					} else {
						valid = this.start_date !== null && this.start_date.length !== 0 && this.start_time && this.start_time.length !== 0 && this.end_time && this.end_time.length !== 0;
					}
				}
				
				if (this.can_edit && this.leave_event_type && this.description.length !== 0 && valid) {
					if (this.isAllday) {
						const start_date_origin = moment(this.current_leave.start_date).format("YYYY-MM-DD");
						const end_date_origin = moment(this.current_leave.end_date).format("YYYY-MM-DD");

						if (this.start_date !== start_date_origin) {
							isActive = true;
						}
						if (this.end_date !== end_date_origin) {
							isActive = true;
						}
						if (this.description !== this.current_leave.description) {
							isActive = true;
						}
						if (this.timezone && this.timezone.key !== this.current_leave.timezone) {
							isActive = true;
						}
						if (this.leave_approval_by && this.leave_approval_by.id !== 0) {
							isActive = true;
						}
						if (this.current_leave.all_day !== this.isAllday) {
							isActive = true;
						}
					} else {
						const start_24_hour = moment(this.start_time, 'h:mm a').format('HH:mm');
						const end_24_hour = moment(this.end_time, 'h:mm a').format('HH:mm');
						
						if (start_24_hour < end_24_hour) {
							const start_date_origin = moment(this.current_leave.start_date).format("YYYY-MM-DD");
							if (this.start_date !== start_date_origin) {
								isActive = true;
							}

							const end_date_origin = moment(this.current_leave.end_date).format("YYYY-MM-DD");
							if (this.end_date !== end_date_origin) {
								isActive = true;
							}

							const start_time_origin = moment(this.current_leave.start_date).format("h:mm a");
							if (this.start_time !== start_time_origin) {
								isActive = true;
							}

							const end_time_origin = moment(this.current_leave.end_date).format("h:mm a");
							if (this.end_time !== end_time_origin) {
								isActive = true;
							}

							if (this.description !== this.current_leave.description) {
								isActive = true;
							}

							if (this.timezone && this.timezone.key !== this.current_leave.timezone) {
								isActive = true;
							}

							if (this.leave_approval_by && this.leave_approval_by.id !== 0) {
								isActive = true;
							}
						}
					}
				}
			}

			return isActive;
		},
		_formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		_timeCheck(is_start){
			const time_start = this.start_time ? this.start_time: '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.end_time ? this.end_time : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
				const time1 = moment(this.start_time, 'h:mm a');
				const time2 = moment(this.end_time, 'h:mm a');
				const budget = time2.diff(time1, 'minutes');
				
				if (budget < 0) {
					if (is_start) {
						this.start_time_error = true;
					} else {
						this.end_time_error = true;
					}
				} 
			}
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
	}
}

</script>
<style lang="scss" scoped>
.top-line {
  width: 100%;
  height: 4px;
  background: #FFB946;
  border-radius: 4px 4px 0px 0px;
}

.leave-content {
	background-color:white;
	max-width: 500px;
	min-height:100%;
}

.leave-content-desktop {
	background: #FFFFFF;
  border-radius: 4px;
  max-width: 100%;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.leave-item-title {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(55, 73, 95, 1);
}

.leave-item-title-disable {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(55, 73, 95, 1);
	opacity: 0.5;
}

.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.paid-button {
	width: 64px;
	height: 36px;
	background-color: rgb(193, 128, 20);
	border-color: rgb(193, 128, 20);
	color:#FFFFFF;
	border-radius: 4px;
	text-align: center;
	
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;

	color: #F45252;
}
.optional-text-red-keyword {
	text-decoration: underline;
	&:hover {
		cursor: pointer;
	}
}

::v-deep {
	.selection .v-select__selections {
		color: #FFFFFF;
		font-family: Roboto;
		font-size: 14px;
		font-weight: 500;
	}
	.selection .theme--light.v-icon {
		color: #FFFFFF;
	}
}
</style>
